export function env(value: string | undefined, defaultValue?: string): string {
    if (value === undefined) {
        if (defaultValue === undefined) throw new Error('Env is required');
        return defaultValue;
    }
    return value;
}

export function envBoolean(value: string | undefined, defaultValue?: boolean): boolean {
    if (value === undefined) throw new Error(`ENV variable unspecified!`);
    if (['true', 'false'].includes(value.trim().toLowerCase())) return value === 'true';
    if (defaultValue === undefined) throw new Error('Boolean env should be true or false');
    return defaultValue;
}
